import React, { createContext, PropsWithChildren, useCallback, useState } from "react";

import { getSearchParams, getUpdatedSearchParamsUrl } from "../../utils/search-params";
import { defaultTabSlug } from "../../utils/tabs";

export interface TabsContextProps {
  activeTab: string | null;
  setActiveTab: (tab: string | null) => void;
}

export const TabsContext = createContext<TabsContextProps>({
  activeTab: null,
  setActiveTab: () => undefined,
});

export interface TabsProviderProps {
  searchParamKey?: string | null;
  initialTab: string;
}

export function TabsProvider({
  children,
  searchParamKey = defaultTabSlug,
  initialTab,
}: PropsWithChildren<TabsProviderProps>) {
  const searchParams = getSearchParams();

  const [activeTab, setTab] = useState<string | null>(
    (searchParamKey !== null ? searchParams?.get(searchParamKey) : null) || initialTab || null
  );

  const setActiveTab = useCallback(
    (tab: string | null) => {
      setTab(tab || null);
      if (typeof window !== "undefined" && searchParamKey !== null) {
        const path = getUpdatedSearchParamsUrl({ [searchParamKey]: tab });
        window.history.pushState({ path }, "", path);
      }
    },
    [searchParamKey]
  );

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>{children}</TabsContext.Provider>
  );
}
